export function NotificationTypeBadge({ type }: { type: string }) {
  const typeStyles: Record<string, string> = {
    success: 'bg-green-500/10 text-green-400',
    warning: 'bg-yellow-500/10 text-yellow-400',
    error: 'bg-red-500/10 text-red-400',
    information: 'bg-blue-500/10 text-blue-400',
    info: 'bg-blue-500/10 text-blue-400',
    action: 'bg-purple-500/10 text-purple-400',
  };
  const style = typeStyles[type] ?? typeStyles.information;
  return (
    <span className={`text-[10px] font-medium tracking-wide px-1.5 py-0.5 rounded ${style}`}>
      {type.toUpperCase()}
    </span>
  );
}
